import { render } from "./MarketplaceView.vue?vue&type=template&id=7c94e992&scoped=true"
import script from "./MarketplaceView.vue?vue&type=script&lang=js"
export * from "./MarketplaceView.vue?vue&type=script&lang=js"

import "./MarketplaceView.vue?vue&type=style&index=0&id=7c94e992&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c94e992"]])

export default __exports__